import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';
import { AuthSession } from './auth-session';
import { ensureAccessToken, getAuthRedirectError, setAuthRedirectError } from './ensure-signed-in';

export const authGuard: CanActivateFn = async () => {
  if (!environment.auth.applicationId) {
    return true;
  }

  const msal = inject(MsalService, { optional: true });
  if (!msal) {
    return true;
  }

  const session = inject(AuthSession);
  try {
    const signedIn = await ensureAccessToken(msal.instance);
    if (signedIn) {
      session.markSignedIn();
      return true;
    }

    session.markSignedOut(getAuthRedirectError());
    return false;
  } catch (error) {
    if (session.authenticated()) {
      return true;
    }

    const message = error instanceof Error ? error.message : 'Sign-in failed.';
    setAuthRedirectError(message);
    session.markSignedOut(message);
    return false;
  }
};
